import { DiscountItemType } from '@hooks-api/types/dataModel/coupon'
import { type ChildOrder, type Transaction } from '@hooks-api/types/dataModel/fpOrder'
import { FastpassOrderStatus } from '@hooks-api/types/dataModel/fpOrder'

export class OrderModel {
  public order: Transaction
  constructor(orderData: Transaction) {
    this.order = orderData
  }

  setOrder(orderData: Transaction) {
    this.order = orderData
  }

  getBundleDiscountItems() {
    return this.order.discount_items?.filter((discount) => {
      return discount.type !== DiscountItemType.SHIPPING_COUPON
    })
  }

  getChildOrders(): Record<string, ChildOrder[]> {
    const childOrders = this.order.child_orders?.reduce<Record<string, ChildOrder[]>>((acc, childOrder) => {
      acc[childOrder.project_code] = acc[childOrder.project_code] || []
      // @ts-expect-error - TODO: fix this
      acc[childOrder.project_code].push(childOrder)
      return acc
    }, {})

    return childOrders ?? {}
  }

  getPayment() {
    return this.order.payment_method?.type
  }

  getCustomNote() {
    return this.order.customer_note
  }

  getCustomDeliveryInfo() {
    return {
      name: this.order.receiver_name,
      phone: this.order.receiver_phone,
      email: this.order.receiver_email,
      address1: this.order.shipping_address,
      note: this.order.customer_note ?? '',
    }
  }

  getTotalInfo() {
    return {
      total: this.order.total ?? null,
      discountAllocations: this.getBundleDiscountItems(),
      shippingFee: this.order.shipping_total ?? null,
      itemAmount: this.order.subtotal ?? null,
      tax: this.order.tax ?? null,
    }
  }

  isOrderConfirm() {
    return this.order.status === 'completed' && this.order.item_confirmed
  }
}

export const getPurchaseStatusClasses = (status: string, style: CSSModuleClasses) => {
  const isOrderCompleted = status === FastpassOrderStatus.COMPLETED
  return `${style.value} ${isOrderCompleted ? style['is-purchased'] : style['none-purchased']}`
}
